import { COLORS } from '@alto/design-library-tokens';
import React from 'react';
import { getBrand } from '../../../utils';
import { Pressable } from '../../buttons';
import { Icon } from '../../icon';
import { TagText } from '../../typography';
import { Tag } from './Tag';

type Props = {
  readonly children: string;
  readonly onPress: () => void;
};

const getTextColor = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return COLORS.TEXT_COLORS.SECONDARY;
  }
  return COLORS.TEXT_COLORS.WHITE;
};

const getIconColor = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return 'secondary';
  }
  return 'white';
};

const getFilterType = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return 'action';
  }
  return 'counter';
};

export const FilterTag = ({ children, onPress }: Props) => {
  return (
    <Pressable onPress={onPress}>
      <Tag
        icon={
          <Icon
            name="chevrondown-small"
            type={getIconColor()}
          />
        }
        isPressable
        label={
          <TagText
            color={getTextColor()}
            variant="small"
          >
            {children}
          </TagText>
        }
        right
        type={getFilterType()}
      />
    </Pressable>
  );
};
